// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__32D1W","insightsList":"newBusinessInsightsMenu_insightsList__29ttm","active":"newBusinessInsightsMenu_active__3-3Rm"};